export function getHpiHardwareIdHeaderValue(username) {
  const normalized =
    typeof username === 'string' ? username.trim().toLowerCase() : ''

  const safeUsername = normalized ? normalized : 'unknown'

  return `${safeUsername}_linktweb`
}

